module.exports = __webpack_public_path__ + "img/img-content-back.aa8131b9.png";